export class Pedido {
   constructor(order_id, order, fecha_pedido, total, fecha_entrega, estatus){
      this.order_id = order_id
      this.order = order
      this.fecha_pedido = fecha_pedido
      this.total = total
      this.fecha_entrega = fecha_entrega
      this.estatus = estatus
   }
   static fromServicePedidos (pedido) {
      return new Pedido(
         pedido.order_id,
         pedido.order,
         pedido.fecha_pedido,
         pedido.total,
         pedido.fecha_entrega,
         pedido.estatus
         );
   }   
}